import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { IReloadPrevent } from '@app/shared/interfaces/reload-prevent';

@Injectable()
export class CanDeactivateGuardService
    implements CanDeactivate<IReloadPrevent> {
    constructor() {}

    async canDeactivate(component: IReloadPrevent): Promise<boolean> {
        if (component.isPreventing()) {
            return await component.onPrevent();
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/can-deactivate-guard.service.ts